/**
 * Аналитика: открытия приложения, экраны, итог окна оплаты.
 *
 * Отправка «выстрелил и забыл»: ошибка аналитики не должна мешать
 * человеку, поэтому сбои здесь гасятся. В режиме просмотра вне Telegram
 * ничего не отправляется — аккаунта нет.
 */
import { retrieveLaunchParams } from '@telegram-apps/sdk-react';
import { z } from 'zod';

import { apiPost } from '@/shared/api/client';
import { isGuest } from '@/shared/lib/guest';

const noContent = z.undefined();

function send(path: string, body: unknown): void {
  if (isGuest()) return;
  apiPost(path, body, noContent).catch(() => {
    // Аналитика не важнее работы приложения.
  });
}

let opened = false;

/** Один раз за запуск. StrictMode вызывает эффекты дважды — флаг это гасит. */
export function trackAppOpened(): void {
  if (opened) return;
  opened = true;
  let startParam: string | undefined;
  try {
    startParam = retrieveLaunchParams().tgWebAppStartParam;
  } catch {
    startParam = undefined;
  }
  send('/activity', { kind: 'app_opened', start_param: startParam ?? null });
}

/** Код экрана по адресу: идентификаторы из пути не уходят. */
export function screenOf(pathname: string): string {
  if (pathname === '/') return 'home';
  if (pathname === '/plans') return 'plans';
  if (pathname === '/profile') return 'profile';
  if (pathname === '/referral') return 'referral';
  if (pathname === '/help') return 'help';
  if (pathname === '/subscriptions') return 'subscriptions';
  if (pathname.startsWith('/subscriptions/')) return 'subscription';
  return 'other';
}

let lastScreen: string | null = null;

export function trackScreen(pathname: string): void {
  const screen = screenOf(pathname);
  if (screen === lastScreen) return;
  lastScreen = screen;
  send('/activity', { kind: 'screen_viewed', screen });
}

export function reportInvoiceClosed(paymentId: string, status: string): void {
  send(`/payments/${paymentId}/invoice-closed`, { status });
}
